import React from "react";
import { Box, Typography, Container, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#000",
    },
  },
  typography: {
    h4: {
      fontWeight: 700,
    },
  },
});

const Dunnage =
  "https://res.cloudinary.com/dgpby6sho/image/upload/f_auto,q_auto/v1/ovum/mnpipocqgbpksbauytse";

const ESD =
  "https://res.cloudinary.com/dnwewxwfl/image/upload/v1774856379/ESD_jtvemg.jpg";

const Fundas =
  "https://res.cloudinary.com/dnwewxwfl/image/upload/v1775364914/Funda_nr73eg.png";

const Cortinas =
  "https://res.cloudinary.com/dnwewxwfl/image/upload/v1774856384/Cortinas_ivi5tp.jpg";

const Textiles =
  "https://res.cloudinary.com/dnwewxwfl/image/upload/v1774856384/Textil_vqflet.jpg";


const Consumibles = 
  "https://res.cloudinary.com/dnwewxwfl/image/upload/v1774856383/Consumibles_vnu46x.jpg";

const LandingProductos = () => {
  const navigate = useNavigate();

  const productos = [
    
    {
      title: "DUNNAGE",
      imageUrl: Dunnage,
      description: "Nos esforzamos por brindar el mejor servicio posible.",
      route: "/Productos",
    },
    {
      title: "ESD",
      imageUrl: ESD,
      description: "Valoramos la diversidad y fomentamos la inclusión.",
      route: "/Productos",
    },
    {
      title: "CORTINAS",
      imageUrl: Cortinas,
      description: "Nos comprometemos a cumplir nuestros objetivos.",
      route: "/Productos",
    },
    {
      title: "FUNDAS INDUSTRIALES",
      imageUrl: Fundas,
      description: "Tomamos responsabilidad de nuestras acciones y decisiones.",
      route: "/Productos",
    },
    {
      title: "CONSUMIBLES",
      imageUrl: Consumibles,
      description: "Nos esforzamos por brindar el mejor servicio posible.",
      route: "/Productos",
    },

    {
      title: "TEXTILES",
      imageUrl: Textiles,
      description: "Apostamos por soluciones creativas e innovadoras.",
      route: "/Productos",
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            color: "#479f19",
            marginBottom: "2rem",
          }}
        >
          <Typography variant="h4">Nuestros Productos</Typography>
        </Box>
        <Grid container spacing={3} justifyContent="center">
          {productos.map((producto, index) => (
            <Grid item xs={6} sm={4} md={3} key={index}>
              <Box onClick={() => navigate("/Catalogo")} sx={{ cursor: "pointer" }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    mb: 0.5,
                    fontSize: { xs: "0.85rem", sm: "1rem", md: "1.1rem" },
                    color: "#333",
                  }}
                >
                  {producto.title}
                </Typography>
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    paddingTop: "75%",
                    overflow: "hidden",
                    borderRadius: "10px",
                    boxShadow: 3,
                    transition: "transform 0.3s",
                    "&:hover": { transform: "scale(1.05)" },
                  }}
                >
                  <img
                    src={producto.imageUrl}
                    alt={producto.title}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </ThemeProvider>
  );
};

export default LandingProductos;
